<template src="./template.html"></template>
<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  props: ['title', 'message', 'type'],
  created(){
    this.closeModalTimeout();
  },
  methods: {
    ...mapActions([
      'SET_NOTIFICATION',
    ]),
    closeModalTimeout() {
      var self = this;
      setTimeout(function(){
        self.$emit('close');
        self.$store.dispatch('SET_NOTIFICATION', {message: '', type: ''})
      }, 5000);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/05_notification/index.vue